<template>
    <c-dialog ref="receivingDia" title="修改收货地址" width="700" @resolve="receivingSubmitForm">
        <c-form ref="receivingForm">
            <c-form-item type="hidden" name="order_number"></c-form-item>
            <c-form-item type="input" label="收货人" name="receiving_name" required></c-form-item>
            <c-form-item type="input" label="电话" name="receiving_phone" required></c-form-item>
            <c-form-item type="region" label="收货地址"
                         province-name="receiving_address_province_id"
                         city-name="receiving_address_city_id"
                         county-name="receiving_address_county_id"
                         required></c-form-item>
            <c-form-item type="input" label="地址详情" name="receiving_address" required></c-form-item>
            <!--
                <c-form-item type="textarea" v-model="analysis_text"  placeholder="请填入收件人姓名、电话、地址信息，系统将自动识别"></c-form-item>
                <m-operate style="position: absolute;right: 0;">
                    <c-button color="red" @click="analysisAddress()" style="margin-right:20px">智能识别</c-button>
                </m-operate>
            -->
        </c-form>
    </c-dialog>
</template>

<script>
    export default {
        props: {
        },
        data() {
            return {
                order_number:'',
                analysis_text:''    //待解析地址
            }
        },
        methods: {

            open(order_number) {
                this.order_number = order_number;
                //查询订单基本信息
                this.request({
                    url: '/order/base_info',
                    data: {
                        order_number:this.order_number
                    },
                    success: data => {
                        var orderObj = data;
                        orderObj.receiving_address = data.receiving_address_details;
                        this.$refs.receivingForm.clear();
                        this.$refs.receivingForm.set(orderObj);
                        this.$refs.receivingDia.open();
                    }
                });
            },

            //地址智能识别
            analysisAddress() {
                if (!this.analysis_text || this.analysis_text.length == 0){
                    this.$message({
                        text: '请输入需要识别的内容',
                        icon: 'fail'
                    });
                    return false;
                }
                this.request({
                    url: '/platform_user/address/analysis',
                    data: {
                        text: this.analysis_text
                    },
                    loading: true,
                    timeout: false,
                    success: (data, message) => {
                        this.$refs.receivingForm.set(data);
                        this.$message({
                            text: '智能识别成功',
                            icon: 'success'
                        });
                    }
                });
            },

            //修改收货地址（提交数据）
            receivingSubmitForm(stop){
                stop();
                this.$refs.receivingForm.submit({
                    url: '/order/edit_receiving_address',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address_province_id: '请选择收货地址省份',
                        receiving_address_city_id: '请选择收货地址城市',
                        receiving_address_county_id: '请选择收货地址区县',
                        receiving_address: '请填写收货地址详情'
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改收货信息成功！'
                        });
                        this.$refs.receivingDia.close();
                        this.$emit('resolve',this.order_number);
                    }
                });
            },
        }
    }
</script>